// src/hooks/useUnreadCount.js
// Счётчик непрочитанных уведомлений — один на всё приложение (колокольчик в шапке и в нижней
// навигации смонтированы одновременно, а опрос должен быть один).
// Запрос при старте, раз в 60 с (только в видимой вкладке) и при возвращении во вкладку.
import { useEffect, useState } from 'react';
import { fetchUnreadCount } from '../services/notificationsService';

const POLL_MS = 60 * 1000;

let count = 0;
const listeners = new Set();
let timer = null;

function publish(value) {
  count = Math.max(0, value);
  listeners.forEach((listener) => listener(count));
}

export async function refreshUnreadCount() {
  try {
    publish(await fetchUnreadCount());
  } catch {
    // нет сети или сессии — оставляем прежнее значение
  }
}

// После действий на экране уведомлений — сразу, не дожидаясь опроса
export function setUnreadCount(value) {
  publish(value);
}

const onVisibilityChange = () => {
  if (document.visibilityState === 'visible') refreshUnreadCount();
};

function startPolling() {
  refreshUnreadCount();
  timer = setInterval(() => {
    if (document.visibilityState === 'visible') refreshUnreadCount();
  }, POLL_MS);
  document.addEventListener('visibilitychange', onVisibilityChange);
}

function stopPolling() {
  clearInterval(timer);
  timer = null;
  document.removeEventListener('visibilitychange', onVisibilityChange);
}

export function useUnreadCount() {
  const [value, setValue] = useState(count);

  useEffect(() => {
    listeners.add(setValue);
    if (listeners.size === 1) startPolling();
    return () => {
      listeners.delete(setValue);
      if (listeners.size === 0) stopPolling();
    };
  }, []);

  return value;
}
